class WPIcon extends HTMLElement {
  constructor(self) {
    self = super(self);
    return self;
  }

  static get is() {
    return 'wp-icon';
  }

  static get ICONS() {
    const context = require.context('../../../svg/', true, /\.svg$/);
    const icons = {};

    context.keys().forEach(function (key) {
      icons[key] = context(key);
    });

    return icons;
  }

  /**
   * Getter for `name` attribute
   */
  get name() {
    return this.hasAttribute('name')
      ? this.getAttribute('name').toLowerCase()
      : '';
  }

  /**
   * Setter for `name` attribute
   */
  set name(value) {
    if (value) {
      this.setAttribute('name', value);
    } else {
      this.removeAttribute('name');
    }
  }

  get _iconPath() {
    return `./${this.name}.svg`;
  }

  connectedCallback() {
    if (!this.name) {
      console.warn('No icon name defined');
      return;
    }

    if (this._iconPath in WPIcon.ICONS) {
      this.innerHTML = WPIcon.ICONS[this._iconPath];
    }
  }
}

customElements.define(WPIcon.is, WPIcon);
